<template>
	<div class="home">
		<van-nav-bar
			:title="$t('NewStaff.title')"
			left-arrow
			fixed
		  	@click-left="$router.push('/StaffList')">
			<van-icon name="./static/img/ok.png" slot="right" @click="createStaff()" style="font-size: 24px;"/>
			<!-- <van-icon name="./static/img/Trash_s.png" slot="right"  style="font-size: 24px;"/> -->
		</van-nav-bar>
		<van-cell-group>
			<van-field
				class="inputAr"
			  	:label="$t('NewStaff.name')"
			  	v-model="staff.name"
			  	:placeholder="$t('NewStaff.placeholderName')"
			/>
			<van-field
				class="inputAr"
			  	:label="$t('NewStaff.gender')"
			  	readonly
			  	clickable
			  	right-icon="arrow"
			  	:value="genderText"
			  	:placeholder="$t('NewStaff.placeholdergender')"
			  	@click="showGenderPicker=true"
			/>
			<van-popup v-model="showGenderPicker" position="bottom">
			  	<van-picker
				    show-toolbar
				    :columns="genders"
				    @cancel="showGenderPicker = false"
				    @confirm="onGenderConfirm"
					:confirm-button-text="$t('vantText.confirm')"
			    	:cancel-button-text="$t('vantText.cancel')"
			  	/>
			</van-popup>
			<van-field
				class="inputAr"
			  	:label="$t('NewStaff.birth')"
			  	readonly
			  	clickable
			  	right-icon="arrow"
			  	:value="staff.birthday | formatDate1"
			  	:placeholder="$t('NewStaff.placeholderBirth')"
			  	@click="showBirthdayPicker = true"
			/>
			<van-popup v-model="showBirthdayPicker" position="bottom">
				<van-datetime-picker
				  	v-model="currentDate"
				  	type="date"
				  	:min-date="minDate"
					:max-date="maxDate"
				  	@cancel="showBirthdayPicker = false"
				    @confirm="staff.birthday=currentDate;showBirthdayPicker = false;"
					:confirm-button-text="$t('vantText.confirm')"
			    	:cancel-button-text="$t('vantText.cancel')"
				/>
			</van-popup>
			<van-popup v-model="showAreaCodePicker" position="bottom">
			  	<van-picker
				    show-toolbar
				    :columns="columns"
				    @cancel="showAreaCodePicker = false"
				    @confirm="onConfirm"
			  	/>
			</van-popup>
			<van-field
				class="inputAr"
			  	:label="$t('NewStaff.phone')"
			  	v-model="staff.phone"
			  	:placeholder="$t('NewStaff.placeholderPhone')"
		  	/>
		  	<van-field
		  		class="inputAr"
			  	:label="$t('NewStaff.workTime')"
			  	readonly
			  	clickable
			  	right-icon="arrow"
			  	:value="staff.entry_time|formatDate1"
			  	:placeholder="$t('NewStaff.placeholderWorkTime')"
			  	@click="showEntryTimePicker = true"
		  	/>
		  	<van-popup v-model="showEntryTimePicker" position="bottom">
				<van-datetime-picker
				  	v-model="currentEntryDate"
				  	type="date"
				  	:min-date="minDate"
				  	@cancel="showEntryTimePicker = false"
				    @confirm="staff.entry_time=currentEntryDate;showEntryTimePicker = false;"
					:confirm-button-text="$t('vantText.confirm')"
			    	:cancel-button-text="$t('vantText.cancel')"
				/>
			</van-popup>
		</van-cell-group>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		staff:{
      			name:'',
      			phone:'',
      			gender:1,
      			birthday:'',
      			entry_time:'',
      			post:'waiter',
      			area_code:'',
      			password:'',
      			store_id:sessionStorage.actShopId,
      		},
      		genders:[
      			{
      				value:1,
      				text:this.$t('NewStaff.man')
      			},
      			{
      				value:0,
      				text:this.$t('NewStaff.woman'),
      			},
      		],
      		posts:[
      			{
      				text:this.$t('NewStaff.staff'),
      				post:'waiter',
      			},
      		],
      		postText:this.$t('NewStaff.staff'),
      		genderText:this.$t('NewStaff.man'),
      		areaName:'',
      		columns:[],
      		showGenderPicker:false,
      		showSetTimePicker:false,
      		showStartTimePicker:false,
      		showAreaCodePicker:false,
      		showBirthdayPicker:false,
      		showEntryTimePicker:false,
      		showPostPicker:false,
      		currentDate: new Date(),
      		currentEntryDate: new Date(),
      		canSubmit:true,
			minDate:new Date(1950, 0, 1),
			maxDate:new Date()
      	}
    },
    mounted:function(){
    	this.getAreacode();
    },
    methods:{
    	onConfirm(value,index) {
	      	this.staff.area_code = this.columns[index].acnumber;
	      	this.areaName =value.text;
	      	this.showAreaCodePicker = false;
    	},
    	onPostConfirm(value,index) {
	      	this.staff.post=this.posts[index].post;
	      	this.postText=this.posts[index].text;
	      	this.showPostPicker = false;
    	},
    	onGenderConfirm(value,index){
    		this.staff.gender=this.genders[index].value;
	      	this.genderText=this.genders[index].text;
	      	this.showGenderPicker = false;
    	},
    	getAreacode(){
    		this.$axios({
                method: 'get',
                url: this.$build+'/api/areacode',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.columns=res.data.data;
                	for(var i = 0;i<this.columns.length;i++){
                		this.columns[i].text=this.columns[i].acnumber+'('+this.columns[i].acname_cn+')';
                	}
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('NewStaff.message'),
        		});
            });
		},
    	createStaff(){
			if(this.staff.name&&this.canSubmit){
				this.canSubmit=false;
				this.$axios({
	                method: 'post',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/user/staff',
	                data:this.staff,
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
	            			vm.$router.push('/StaffList');
		            	},1500);     
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            	this.canSubmit=true;
	            }).catch(err => {
	            	this.canSubmit=true;
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('NewStaff.message'),
            		});
	            });
			}else{
				this.$toast(this.$t('NewStaff.toast'));
			}
    	},
    },
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	/deep/ .van-field__label{
		width: 130px;
	}
	.home{
		width: 100%;
		height: 100vh;
	}
	.inputAr .van-field__body input{
		text-align: right;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#2f75f4;
	}
	.selSex{
        width: 50px;
        float: right;
    }
</style>




// WEBPACK FOOTER //
// src/Staff/newStaff.vue